import httpClient, { paramsToString } from '@/services/http/httpClient'
import serializeObject from '@/utils/serializeObject'
import * as Settings from '@/infra/settings'

export const apiGetMenus = (FNOLTabsParams) => {
  return httpClient.get('menus/', {
    params: FNOLTabsParams
  })
}

export const apiGetForm = (warrantyId, formParams, lang) => {
  const parsedParams = (Object.keys(formParams).length > 0 ? '?' : '') + serializeObject(formParams)
  return httpClient.get(`forms/${warrantyId}/${parsedParams}`)
}

export const apiGetGenericFormsList = () => {
  return httpClient.get('forms/selfcare/')
}

export const apiGetFnolIds = () => {
  return httpClient.get('fnol/flux')
}

export const apiSearchPredictibles = (warrantyId) => {
  return httpClient.get(`/assets/browser/shortcuts/${warrantyId}`)
}

export const apiSearchMobilier = (warrantyId, literal) => {
  const params = new URLSearchParams()
  params.append('lang', Settings.getLocale())

  if (literal != null) {
    params.append('literal', literal)
  }

  return httpClient.get(`assets/browser/${warrantyId}${paramsToString(params)}`)
}
